import React from 'react';
import OLYWebPageComponent from '../components/OLYWebPageComponent';
import DynIcon from '../components/Utils/DynIcon';
import { translate } from 'react-i18next';
import { LinearProgress } from 'material-ui';
import { Typography } from 'material-ui';
import { Grid } from 'material-ui';
import { withStyles } from 'material-ui';
import { getCMSWidgetComponent } from './cmsLib';
import PopUpDialog from './PopUpDialog';
import { connect } from 'react-redux';
import { cleanHotelTabs } from '../actions/tabActions';
import { cleanSelection } from '../actions/selectSuggestionActions';


const styles = theme => ({
    tableTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 300
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: '#3155A1',
    }
});
class Home extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            dialogOpen: false,
        };
        this.pageName = 'HOME';

        this.to = setTimeout(() => {
            this.setState({ loading: false });
        }, 2000);
        this.__hashChanged();
    }

    componentDidMount() {
        this.props.dispatch(cleanHotelTabs())
        this.props.dispatch(cleanSelection())
    }

    handleCloseDialog = value => {
        //si tengo value el usuario apreto confirmar
        this.setState({ dialogOpen: false });
    };

    handleOpenDialog = value => {
        //si tengo value el usuario apreto confirmar
        this.setState({ dialogOpen: true });
    };    

    render() {
        const { t } = this.props;
        return (
            <div className="cmsHome">
                <div className="cmsContainer">
                    <div style={{ height: '10px' }}>
                        {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                    </div>
                    <Typography>
                        <DynIcon icon="Hotel" />
                        <strong style={{ paddingLeft: 8 }}>{t(this.pageTitle)}</strong>
                    </Typography>
                    <Grid container justify="center" className="gridTop">
                        <Grid item xs={4}>
                            {getCMSWidgetComponent(2)}
                        </Grid>
                        <Grid item xs={8}>
                            {getCMSWidgetComponent(3)}
                        </Grid>
                    </Grid>
                    <Grid container justify="center" className="gridCenter cmsSmallHeight">
                        <Grid item xs>
                            {getCMSWidgetComponent(4, { slidesToShow: 3, slidesToScroll: 3 }, 'cmsHomeCenter')}
                        </Grid>
                    </Grid>
                    <Grid container justify="center" className="gridBottom">
                        <Grid item xs={6}>
                            {getCMSWidgetComponent(5)}
                        </Grid>
                        <Grid item xs={6}>
                            {getCMSWidgetComponent(6)}
                        </Grid>
                    </Grid>
                    <PopUpDialog
                        open={this.state.dialogOpen}
                        onOpen={this.handleOpenDialog}
                        onClose={this.handleCloseDialog}
                    />               
                </div>
            </div>
        );
    }
}

export default connect()(translate('translations')(withStyles(styles)(Home)));


// WEBPACK FOOTER //
// ./src/cms/Home.js